/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Costs_QualityInputs */

const en_directory_ai_tools_costs_quality = /** @type {(inputs: Directory_Ai_Tools_Costs_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality`)
};

const zh_directory_ai_tools_costs_quality = /** @type {(inputs: Directory_Ai_Tools_Costs_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画质`)
};

/**
* | output |
* | --- |
* | "Quality" |
*
* @param {Directory_Ai_Tools_Costs_QualityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_costs_quality = /** @type {((inputs?: Directory_Ai_Tools_Costs_QualityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Costs_QualityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_costs_quality(inputs)
	return zh_directory_ai_tools_costs_quality(inputs)
});
export { directory_ai_tools_costs_quality as "directory.ai_tools.costs.quality" }